import { MenuItem, TextField } from '@mui/material';
import { useField } from 'formik';
import React from 'react';

// Formik-bound MUI Select rendered as a TextField with `select` so we
// inherit consistent label/helper behavior.  `options` is an array of
// `{ value, label }`; pass `null`/empty-string-friendly options if a
// blank choice should be available.
export default function SettingsSelectField({ name, label, options, helperText, ...rest }) {
  const [field, meta] = useField(name);
  const showError = Boolean(meta.touched && meta.error);
  return (
    <TextField
      {...field}
      {...rest}
      variant="filled"
      select
      label={label}
      error={showError}
      helperText={showError ? meta.error : helperText}
      fullWidth
      value={field.value ?? ''}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
